import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { BgColorsOutlined } from '@ant-design/icons';
import SubMenuIndexes from 'modules/layoutModule/enums/SubMenuIndexes';
import MenuIndexes from 'modules/layoutModule/enums/MenuIndexes';
import {
  FertilizersModulesList,
  FertilizersSubModuleDefinition,
} from 'enums/modulesDefinition';

const { SubMenu } = Menu;

export const FertilizersMenuTab = (
  subMenuClick: any,
  setSelectedMenu: any,
  subModulesData: any,
  title: string,
  userModules: any[]
) => {
  const renderSubModules = (el: any) => {
    switch (el.id) {
      case FertilizersSubModuleDefinition.fertilizersAdd:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZERS_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilizers/add">{el.title}</Link>
          </Menu.Item>
        );
      case FertilizersSubModuleDefinition.fertilizers:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZERS}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilizers">{el.title}</Link>
          </Menu.Item>
        );
      case FertilizersSubModuleDefinition.fertilizersParametersAdd:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZERS_PARAMETERS_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilizers-parameters/add">{el.title}</Link>
          </Menu.Item>
        );
      case FertilizersSubModuleDefinition.fertilizersParameters:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZERS_PARAMETERS}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilizers-parameters">{el.title}</Link>
          </Menu.Item>
        );
      case FertilizersSubModuleDefinition.fertilizersDictionary:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZERS_DICTIONARY}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilizers-dictionary">{el.title}</Link>
          </Menu.Item>
        );
      default:
        return null;
    }
  };

  const checkPermissions = FertilizersModulesList.filter((module) => {
    if (userModules.includes(module.id)) return module;
  });

  if (checkPermissions.length === 0) {
    return <></>;
  }

  return (
    <>
      <SubMenu
        icon={<BgColorsOutlined />}
        title={title}
        onTitleClick={(e) => subMenuClick(e)}
        key={SubMenuIndexes.FERTILIZERS}
      >
        {checkPermissions.map((module) => renderSubModules(module))}
      </SubMenu>
    </>
  );
};
